import React from "react";
import { AllCards } from "Pages";
import { Searchbar } from "Components";
import "./style.css";

export const Home = () => {
  return (
    <div className="flex_c gap-40  main_container justify_content_start">
      <div className="display_none_Home">
        <div className="flex_r centering_the_searchbar" >
          <Searchbar className="login_input navbar_search_form" />
        </div>
      </div>
      <AllCards />
    </div>
  );
};
